import {
  SEARCH_ATIVOS_CHANGED,
  SEARCH_ATIVOS_LOGOUT,
} from "../../const/actionsType";

export function acSearchAtivosChanged(pData) {
  return {
    type: SEARCH_ATIVOS_CHANGED,
    payload: pData,
  };
}

export function acSearchAtivosLogout() {
  return {
    type: SEARCH_ATIVOS_LOGOUT,
  };
}
